








import { Vue, Component } from 'vue-property-decorator';
import Banner from '@/components/Banner.vue';
import BottomTabbar from '@/components/BottomTabbar.vue';
import { OPTHINES } from './config';
import { getBaseInfo } from './api';

@Component({
  components: {
    Banner,
    BottomTabbar,
  },
})
export default class Home extends Vue {
  option = OPTHINES;
  data: any = {
    banner:
      'https://image2.cqcb.com/d/file/topics/activity/2020-07-16/6tiLPiLp-1594885726341.png',
  };

  created() {
    this.getBaseInfo();
  }

  async getBaseInfo() {
    this.$addPv(154);
    this.$appShareInfo({
      title: '第六届“紫荆杯”两岸暨港澳青少年书画大赛启幕  邀你共“绘”花好月圆！',
      url: window.location.href,
      subtitle: '第六届“紫荆杯”两岸暨港澳青少年书画大赛启幕  邀你共“绘”花好月圆！',
      classId: -1,
      id: -1,
      image: 'http://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg',
      type: 3,
    });

    this.$wxShareInfo({
      title: '第六届“紫荆杯”两岸暨港澳青少年书画大赛启幕  邀你共“绘”花好月圆！',
      subtitle: '第六届“紫荆杯”两岸暨港澳青少年书画大赛启幕  邀你共“绘”花好月圆！',
      image: 'http://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg',
    });
  }
}
